// /forms/user/transformPayload.js

export const transformPayload = (
  formData,
  outboundFlights,
  inboundFlights,
  tripName
) => ({
  currentTripId: formData.currentTripId,
  personalInfoDTO: {
    personalId: formData.personalId || null,
    tripId: formData.tripId,
    firstName: formData.firstName,
    lastName: formData.lastName,
    preferredName: formData.preferredName,
    mi: formData.mi || null,
    phone: formData.phone,
    countryCode: formData.countryCode,
    email: formData.email,
    address: formData.address,
    city: formData.city,
    state: formData.state,
    zip: formData.zip,
    country: formData.country,
    citizenship: formData.citizenship,
    passportNo: formData.passportNo,
    passportExp: formData.passportExp,
    newPassport:
      formData.newPassport === "true" || formData.newPassport === true,
    visaForGr: formData.visaForGr === "true" || formData.visaForGr === true,
    dob: formData.dob,
    gender: formData.gender,
    ageGroup: formData.ageGroup,
    fileCopy: formData.fileCopy,
    createdAt: null,
    createdBy: null,
    modifiedAt: null,
    modifiedBy: null,
    tshirtSize: formData.tshirtSize || null,
    isKnownUser: formData.isKnownUser || null,
    childInvite: localStorage.getItem("isInvited")
      ? localStorage.getItem("isInvited")
      : formData.userType || null,
    isParticipant: formData.participant || false,
    renewPassport: formData.renewPassport,
    noPassport: formData.noPassport,
  },
  emergencyContactDTO: {
    contactId: formData.ecContactId || null,
    personalId: formData.personalId || null,
    firstName: formData.ecFirstName,
    lastName: formData.ecLastName,
    phone: formData.ecPhone,
    countryCode: formData.ecCountryCode,
    country: formData.ecCountry,
    tripId: formData.tripId,
    createdAt: null,
    createdBy: null,
    modifiedAt: null,
    modifiedBy: null,
  },
  medicalInfoDTO: {
    medicalId: formData.medicalId || null,
    personalId: formData.personalId || null,
    tripId: formData.tripId,
    medicalIssues: formData.medicalIssues,
    medications: formData.medications,
    allergies: formData.allergies,
    walkIssue: formData.walkIssue,
    preferredSeat: formData.preferredSea,
    carSick: formData.carSick,
    seaSick: formData.seaSick,
    foodAllergies: formData.foodAllergies,
    specifics: formData.specifics || null,
    dietaryPreferences: formData.dietaryPreferences || null,
    dietaryPreferencesDetails: formData.dietaryPreferencesDetails,
    packageOption: formData.packageOption,
    createdAt: new Date().toISOString(),
    createdBy: "admin",
    modifiedAt: new Date().toISOString(),
    modifiedBy: "admin",
  },
  flightDetailDto: [
    ...outboundFlights.map((f, index) => ({
      flightId: f.flightId || null,
      personalId: formData.personalId || null,
      departureDate: f.departureDate,
      departureTime: f.departureTime,
      arrivalDate: f.arrivalDate,
      arrivalTime: f.arrivalTime,
      airportFrom: f.airportFrom,
      airportTo: f.airportTo,
      flightNumber: f.flightNumber,
      airline: f.airline || null,
      tripId: formData.currentTripId || null,
      legNumber: index + 1,
      travelDirection: "Outbound",
      createdAt: new Date().toISOString(),
      createdBy: "admin",
      modifiedAt: new Date().toISOString(),
      modifiedBy: "admin",
    })),
    ...inboundFlights.map((f, index) => ({
      flightId: f.flightId || null,
      personalId: formData.personalId || null,
      departureDate: f.departureDate,
      departureTime: f.departureTime,
      arrivalDate: f.arrivalDate,
      arrivalTime: f.arrivalTime,
      airportFrom: f.airportFrom, // Match input field names
      airportTo: f.airportTo,
      flightNumber: f.flightNumber,
      airline: f.airline || null,
      tripId: formData.currentTripId || null,
      legNumber: index + 1,
      travelDirection: "Inbound",
      createdAt: new Date().toISOString(),
      createdBy: "admin",
      modifiedAt: new Date().toISOString(),
      modifiedBy: "admin",
    })),
  ],

  cruiseAccommodationDTO: {
    cruiseAccommodationId: formData.cruiseAccommodationId || null,
    cruiseType: formData.Cruise,
    personalId: formData.personalId || null,
    tripId: formData.currentTripId || null,
    createdAt: new Date().toISOString(),
    createdBy: "admin",
    modifiedAt: new Date().toISOString(),
    modifiedBy: "admin",
  },
  hotelAccommodationDTO: {
    hotelAccommodationId: formData.hotelAccommodationId || null,
    hotelType: formData.Category,
    partySize: formData.party,
    personalId: formData.personalId || null,
    tripId: formData.currentTripId || null,
    createdAt: new Date().toISOString(),
    createdBy: "admin",
    modifiedAt: new Date().toISOString(),
    modifiedBy: "admin",
  },

  tourPackageOptionDTO:
    formData.tourOptions
      ?.filter(
        (option) =>
          option.packageOptionId && option.price && option.packageOption
      ) // ✅ Remove nulls
      .map((option) => ({
        packageOptionId: option.packageOptionId,
        packageOption: option.packageOption,
        price: option.price,
        createdAt: new Date().toISOString(),
        createdBy: "admin",
        modifiedAt: new Date().toISOString(),
        modifiedBy: "admin",
        country: option.country,
        currency: option.currency,
      })) || [],

  // travelChoiceDTO: formData.travelerChoice?.map((option) => ({
  //   choiceId: formData.choiceId || null,
  //   travelPreferences: option,
  //   personalId: formData.personalId || null,
  //   tripId: formData.currentTripId || null,
  //   // tripId: 33,
  //   createdAt: new Date().toISOString(),
  //   createdBy: "admin",
  //   modifiedAt: new Date().toISOString(),
  //   modifiedBy: "admin",
  // })),

  participants: formData.participants || [],
  parentDto: {
    name: localStorage.getItem("parentName") || null,
    email: localStorage.getItem("parentEmail") || null,
  },
  participant: false,
  file: formData.file,

  // CONDITIONAL BLOCK (EUROPE ONLY)
  ...(tripName?.toLowerCase().includes("europe") && {
    additionalPersonalInfoDto: {
      additionalId: formData.additionalId,
      conferenceMissionUnion: formData.conferenceMissionUnion,
      willingToLeadGroup: formData.willingToLeadGroup,
      languagesSpoken: formData.languagesSpoken,
      photographicConsent: formData.photographicConsent,
      agreeTermsConditions: formData.agreeTermsConditions,
      createdAt: new Date().toISOString(),
      createdBy: "admin",
      modifiedAt: new Date().toISOString(),
      modifiedBy: "admin",
      personalId: formData.personalId || null,
      tripId: formData.tripId,
      tshirtSize: formData.tshirtSize,
    },
  }),
});

export const transformPayloadOfParticipant = (
  formData,
  participantOutboundFlights,
  participantInboundFlights,
  tripId
) => ({
  personalInfoDTO: {
    personalId: formData.personalId || null,
    tripId: formData.tripId || tripId,
    firstName: formData.firstName,
    lastName: formData.lastName,
    preferredName: formData.preferredName,
    mi: formData.mi || null,
    phone: formData.phone,
    countryCode: formData.countryCode,
    email: formData.email,
    address: formData.address,
    city: formData.city,
    state: formData.state,
    zip: formData.zip,
    country: formData.country,
    citizenship: formData.citizenship,
    passportNo: formData.passportNo,
    passportExp: formData.passportExp,
    newPassport:
      formData.newPassport === "true" || formData.newPassport === true,
    visaForGr: formData.visaForGr === "true" || formData.visaForGr === true,
    dob: formData.dob,
    gender: formData.gender,
    ageGroup: formData.ageGroup,
    fileCopy: formData.fileCopy,
    createdAt: null,
    createdBy: null,
    modifiedAt: null,
    modifiedBy: null,
    tshirtSize: formData.tshirtSize || null,
    participant: formData.participant || false,
    isKnownUser: formData.isKnownUser || null,
    childInvite: localStorage.getItem("isInvited")
      ? localStorage.getItem("isInvited")
      : formData.isInvited || "no",
    renewPassport: formData.renewPassport,
    noPassport: formData.noPassport,
  },
  medicalInfoDTO: {
    medicalId: formData.medicalId || null,
    personalId: formData.personalId || null,
    tripId: formData.tripId || tripId,
    medicalIssues: formData.medicalIssues,
    medications: formData.medications,
    allergies: formData.allergies,
    walkIssue: formData.walkIssue,
    preferredSeat: formData.preferredSeat,
    carSick: formData.carSick,
    seaSick: formData.seaSick,
    foodAllergies: formData.foodAllergies,
    specifics: formData.specifics || null,
    dietaryPreferences: formData.dietaryPreferences || null,
    dietaryPreferencesDetails: formData.dietaryPreferencesDetails || null,
    packageOption: formData.packageOption || null,
    createdAt: new Date().toISOString(),
    createdBy: "admin",
    modifiedAt: new Date().toISOString(),
    modifiedBy: "admin",
  },

  flightDetailDto: [
    ...participantOutboundFlights.map((f, index) => ({
      flightId: f.flightId || null,
      personalId: formData.personalId || null,
      departureDate: f.departureDate,
      departureTime: f.departureTime,
      arrivalDate: f.arrivalDate,
      arrivalTime: f.arrivalTime,
      airportFrom: f.airportFrom,
      airportTo: f.airportTo,
      flightNumber: f.flightNumber,
      airline: f.airline || null,
      tripId: formData.currentTripId || null,
      legNumber: index + 1,
      travelDirection: "Outbound",
      createdAt: new Date().toISOString(),
      createdBy: "admin",
      modifiedAt: new Date().toISOString(),
      modifiedBy: "admin",
    })),
    ...participantInboundFlights.map((f, index) => ({
      flightId: f.flightId || null,
      personalId: formData.personalId || null,
      departureDate: f.departureDate,
      departureTime: f.departureTime,
      arrivalDate: f.arrivalDate,
      arrivalTime: f.arrivalTime,
      airportFrom: f.airportFrom, // Match input field names
      airportTo: f.airportTo,
      flightNumber: f.flightNumber,
      airline: f.airline || null,
      tripId: formData.currentTripId || null,
      legNumber: index + 1,
      travelDirection: "Inbound",
      createdAt: new Date().toISOString(),
      createdBy: "admin",
      modifiedAt: new Date().toISOString(),
      modifiedBy: "admin",
    })),
  ],

  tourPackageOptionDTO: [],
  file: formData.file,
  participant: true,
});

export const reconstructFormDataOfParticipant = (apiData) => {
  const pi = apiData.personalInfoDTO || {};
  const mi = apiData.medicalInfoDTO || {};
  const flights = apiData.flightDetailDto || [];

  return {
    participantExists: apiData.participantExists,
    personalId: pi.personalId,
    tripId: mi.tripId,
    firstName: pi.firstName,
    lastName: pi.lastName,
    preferredName: pi.preferredName,
    mi: pi.mi,
    phone: pi.phone,
    countryCode: pi.countryCode,
    email: pi.email,
    address: pi.address,
    city: pi.city,
    state: pi.state,
    zip: pi.zip,
    country: pi.country,
    citizenship: pi.citizenship,
    passportNo: pi.passportNo,
    passportExp: pi.passportExp,
    newPassport: pi.newPassport,
    visaForGr: pi.visaForGr,
    dob: pi.dob,
    renewPassport: pi.renewPassport,
    noPassport: pi.noPassport,
    gender: pi.gender,
    ageGroup: pi.ageGroup,
    fileCopy: pi.fileCopy,
    tshirtSize: pi.tshirtSize,
    participant: pi.participant,
    addressConfirmation: true,
    passportConfirmation: true,
    isKnownUser: pi.isKnownUser,
    isInvited: pi.childInvite,

    medicalId: mi.medicalId,
    medicalIssues: mi.medicalIssues,
    dietaryPreferencesDetails: mi.dietaryPreferencesDetails,
    packageOption: mi.packageOption,
    medications: mi.medications,
    allergies: mi.allergies,
    walkIssue: mi.walkIssue,
    preferredSeat: mi.preferredSeat,
    carSick: mi.carSick,
    seaSick: mi.seaSick,
    foodAllergies: mi.foodAllergies,
    specifics: mi.specifics,
    dietaryPreferences: mi.dietaryPreferences,

    outboundFlights: flights
      .filter((f) => f.travelDirection === "Outbound")
      .map((f) => ({ ...f, flightBoundConfirmation: true })),
    inboundFlights: flights
      .filter((f) => f.travelDirection === "Inbound")
      .map((f) => ({ ...f, flightBoundConfirmation: true })),
  };
};

export const reconstructFormData = (apiData) => {
  const pi = apiData.personalInfoDTO || {};
  const ec = apiData.emergencyContactDTO || {};
  const mi = apiData.medicalInfoDTO || {};
  const flights = apiData.flightDetailDto || [];
  const hotelDetails =
    apiData.hotelAccommodationDTOS?.length > 0
      ? apiData.hotelAccommodationDTOS[0]
      : [] || null;
  const cruiseDetails =
    apiData.cruiseAccommodationDTOS.length > 0
      ? apiData.cruiseAccommodationDTOS[0]
      : [];
  const currentTripId = apiData.tripId;
  const Parent = apiData.parentDto || {};
  const additionalPersonal = apiData.additionalPersonalInfoDto || {};

  return {
    participantExists: apiData.participantExists,
    participantCount: apiData.participants?.length || 0,
    currentTripId: currentTripId,
    personalId: pi.personalId,
    tripId: ec.tripId,
    firstName: pi.firstName,
    lastName: pi.lastName,
    preferredName: pi.preferredName,
    mi: pi.mi,
    phone: pi.phone,
    countryCode: pi.countryCode,
    email: pi.email,
    address: pi.address,
    city: pi.city,
    state: pi.state,
    zip: pi.zip,
    country: pi.country,
    citizenship: pi.citizenship,
    passportNo: pi.passportNo,
    passportExp: pi.passportExp,
    newPassport: pi.newPassport,
    visaForGr: pi.visaForGr,
    dob: pi.dob,
    renewPassport: pi.renewPassport,
    noPassport: pi.noPassport,
    gender: pi.gender,
    ageGroup: pi.ageGroup,
    fileCopy: pi.fileCopy,
    // tshirtSize: pi.tshirtSize,
    isKnownUser: pi.isKnownUser,
    isInvited: pi.childInvite,
    participant: pi.participant,
    addressConfirmation: true,
    passportConfirmation: true,
    ParentName: Parent.name,
    ParentEmail: Parent.email,

    ecContactId: ec.contactId,
    ecFirstName: ec.firstName,
    ecLastName: ec.lastName,
    ecPhone: ec.phone,
    ecCountryCode: ec.countryCode,
    ecCountry: ec.country,

    medicalId: mi.medicalId,
    dietaryPreferencesDetails: mi.dietaryPreferencesDetails,
    packageOption: mi.packageOption,

    medicalIssues: mi.medicalIssues,
    medications: mi.medications,
    allergies: mi.allergies,
    walkIssue: mi.walkIssue,
    preferredSeat: mi.preferredSeat,
    carSick: mi.carSick,
    seaSick: mi.seaSick,
    foodAllergies: mi.foodAllergies,
    specifics: mi.specifics,
    dietaryPreferences: mi.dietaryPreferences,

    cruiseAccommodationId: cruiseDetails.cruiseAccommodationId,
    Cruise: cruiseDetails.cruiseType,

    hotelAccommodationId: hotelDetails.hotelAccommodationId,
    party: hotelDetails.partySize,
    Category: hotelDetails.hotelType,

    outboundFlights: flights
      .filter((f) => f.travelDirection === "Outbound")
      .map((f) => ({ ...f, flightBoundConfirmation: true })),
    inboundFlights: flights
      .filter((f) => f.travelDirection === "Inbound")
      .map((f) => ({ ...f, flightBoundConfirmation: true })),

    packageOptionId:
      apiData.tourPackageOptionDTOS && apiData.tourPackageOptionDTOS.length > 0
        ? apiData.tourPackageOptionDTOS[0]?.packageOptionId || null
        : null,
    tourOptions: apiData.tourPackageOptionDTOS
      ? apiData.tourPackageOptionDTOS
      : [] || null,

    choiceId: apiData.travelChoiceDTOS[0]?.choiceId || null,
    travelerChoice:
      apiData.travelChoiceDTOS?.map((choice) => choice.travelPreferences) || [],
    participants: apiData.participants || [],
    termsConditions: true,
    insuranceConsent: true,

    // Additional PersonalInfo
    additionalId: additionalPersonal.additionalId,
    conferenceMissionUnion: additionalPersonal.conferenceMissionUnion,
    willingToLeadGroup: additionalPersonal.willingToLeadGroup,
    languagesSpoken: additionalPersonal.languagesSpoken,
    photographicConsent: additionalPersonal.photographicConsent,
    agreeTermsConditions: additionalPersonal.agreeTermsConditions,
    tshirtSize: additionalPersonal.tshirtSize,
  };
};
